/**
 * Who has opened a document. ADR 0020, decisions 8, 9 and 10.
 *
 * Two questions, two answers. A published document says who still has to read
 * it, counting current memberships, so the number can reach the total and stay
 * there. A private one says who opened it and when, every time, which is what
 * the employee it belongs to is entitled to see.
 */
import { useDocumentReads } from '@/api/data';
import { T } from '@/i18n';
import { Empty, Skeleton } from '@/ui';
import { fmtD } from '@/ui/format';

export function DokumentLesere({ id }: { id: number }) {
  const q = useDocumentReads(id);
  if (q.isPending) return <Skeleton />;
  if (q.isError) return <Empty>{T('Fikk ikke hentet hvem som har åpnet dokumentet.')}</Empty>;

  const { scope, entries, outstanding } = q.data;
  const read = entries.length;
  const total = read + outstanding.length;

  return (
    <div data-testid="document-readers" style={{ padding: '8px 14px' }}>
      {scope === 'shared' ? (
        <p className="hint">
          {read} {T('av')} {total} {T('har lest')}
        </p>
      ) : null}
      {entries.length ? (
        entries.map((e, i) => (
          <div className="prow" key={`${e.userId}-${i}`}>
            <b>{e.name ?? `#${e.userId}`}</b>
            <span className="pv">{fmtD(String(e.readAt).slice(0, 10))}</span>
          </div>
        ))
      ) : (
        <Empty>{scope === 'shared' ? T('Ingen har lest den ennå.') : T('Ingen har åpnet dette.')}</Empty>
      )}
      {scope === 'shared' && outstanding.length ? (
        <>
          <p className="hint" style={{ marginTop: 8 }}>
            {T('Har ikke lest')}
          </p>
          {outstanding.map((o) => (
            <div className="prow" key={o.userId}>
              <b>{o.name}</b>
              <span className="pv">–</span>
            </div>
          ))}
        </>
      ) : null}
    </div>
  );
}
